import React, { useState, useEffect } from "react";
import { Row, Col, Card, Statistic, Tabs, Typography } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";

import DashboardCharts from "./Usercomp/DashboardChart";

import {
  useGetAllStrategyQuery,
  useAssignStrategyMetricsQuery,
  useGetStrategyMetricsQuery,
} from "../slices/strategyApiSlice";
import InsightsCard from "./Usercomp/insightChart";

const { Title } = Typography;

const Dashboard = () => {
  // get strategies
  const { data: strategies } = useGetAllStrategyQuery();

  const strategyList = strategies?.data || [];

  // selected strategy
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  // 👇 automatically fetch metrics when strategy changes
  const { data: metrics } = useGetStrategyMetricsQuery(selectedStrategy, {
    skip: !selectedStrategy,
  });

  useEffect(() => {
    if (strategyList.length && !selectedStrategy) {
      setSelectedStrategy(strategyList[0].id);
    }
  }, [strategyList]);

  const handleStrategyChange = (key) => {
    setSelectedStrategy(key);
  };
  // // mutation to fetch metrics


  return (
    <div>
      <Title level={2}>Strategy Dashboard</Title>

      {/* Strategy Tabs */}
      <Tabs
        activeKey={selectedStrategy}
        onChange={handleStrategyChange}
        items={strategyList.map((s) => ({
          key: s.id,
          label: s.name,
        }))}
      />

      {/* Stats Row */}
      <Row gutter={[16, 24]} style={{ marginBottom: "10px" }}>
        <Col md={6} xs={24}>
          <Card>
            <Statistic
              title="Realised (P&L)"
              value={metrics?.total_profit || 0}
              precision={2}
              valueStyle={{
                color: metrics?.total_profit > 0 ? "#27ae60" : "#c0392b",
              }}
              prefix={
                metrics?.total_profit > 0 ? (
                  <ArrowUpOutlined />
                ) : (
                  <ArrowDownOutlined />
                )
              }
              suffix="₹"
            />
          </Card>
        </Col>

        <Col md={6} xs={24}>
          <Card>
            <Statistic
              title="Trade Win %"
              value={metrics?.win_rate || 0}
              suffix="%"
              valueStyle={{ color: "#2980b9" }}
            />
          </Card>
        </Col>

        <Col md={6} xs={24}>
          <Card>
            <Statistic
              title="Profit Factor"
              value={metrics?.profit_factor || 0}
              precision={2}
              valueStyle={{ color: "#2980b9" }}
            />
          </Card>
        </Col>

        <Col md={6} xs={24}>
          <Card>
            <Statistic
              title="Total Trades"
              value={metrics?.total_trades || 0}
              valueStyle={{ color: "#2980b9" }}
            />
          </Card>
        </Col>
      </Row>

      {/* Charts */}
      <Row gutter={[16, 24]}>
        <DashboardCharts data={metrics}  />
        
      </Row>
    </div>
  );
};

export default Dashboard;